import React from 'react';
import styles from './style.module.css';

import { Button } from '../../elements';
import BrandLogo from '../../../assets/img/watertools-logo.png';

export default function HeaderSection() {
  return (
    <div className={styles.root}>
      <div className={styles.leftSide}>
        <div className={styles.websiteDescriptionBox}>
          <h1>PERTAMINA WATER TOOLS</h1>
          <span className={styles.subtitle}>
            Pengelolaan Sumber Daya Air Pertamina
          </span>
          <p>
            Water tools risk assessment yang berbasiskan web apps atau desktop
            apps yang dapat diakses secara offline, dengan output report dengan
            format ini dikembangkan oleh Pertamina dengan tujuan meningkatkan
            Sustainability Focus, Reducing Environmental Footprint, Pengelolaan
            Sumber daya Air dan Pengendalian Resiko
          </p>
          <Button
            label="Gunakan Pertamina Water Tools Sekarang"
            color="secondary"
          />
        </div>
      </div>
      <div className={styles.rightSide}>
        <img src={BrandLogo} alt="Logo Pertamina Watertools" />
      </div>
    </div>
  );
}
